import React, { useEffect, useRef, useState } from 'react';

const STORAGE_KEY = 'liina-intro-played'

// 再生を終えるまで最大で待つ時間。再生が途中で止まってもページを開けるようにする
const SAFETY_TIMEOUT = 12000
const FADE_DURATION = 400

// 再生できない端末で暗い画面が一瞬出るのを避けるため、先に対応可否を確かめる
const canPlayVideo = () => {
    return document.createElement('video').canPlayType('video/mp4; codecs="avc1.42E01E"') !== ''
}

export const shouldPlayIntro = () => {
    if (typeof window === 'undefined') {
        return false
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return false
    }
    if (!canPlayVideo()) {
        return false
    }
    try {
        return window.localStorage.getItem(STORAGE_KEY) !== 'played'
    } catch (e) {
        // プライベートモードなどで参照できない場合は初回として扱う
        return true
    }
}

export const rememberIntroPlayed = () => {
    try {
        window.localStorage.setItem(STORAGE_KEY, 'played')
    } catch (e) {
        // 保存できなくても表示自体は妨げない
    }
}

const Intro = ({ onFinish }) => {
    const videoRef = useRef(null)
    const [isLeaving, setIsLeaving] = useState(false)

    useEffect(() => {
        const video = videoRef.current
        let fadeTimer = null

        const finish = () => {
            if (fadeTimer) {
                return
            }
            setIsLeaving(true)
            fadeTimer = setTimeout(onFinish, FADE_DURATION)
        }

        video.addEventListener('ended', finish)
        video.addEventListener('error', finish)

        // 端末の設定で自動再生が拒否されたときもページを見られるようにする
        const playback = video.play()
        if (playback && typeof playback.catch === 'function') {
            playback.catch(finish)
        }

        const safetyTimer = setTimeout(finish, SAFETY_TIMEOUT)

        // 再生中は背後のページをスクロールさせない
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'

        return () => {
            video.removeEventListener('ended', finish)
            video.removeEventListener('error', finish)
            clearTimeout(fadeTimer)
            clearTimeout(safetyTimer)
            document.body.style.overflow = previousOverflow
        }
    }, [onFinish])

    return (
        <div className={isLeaving ? 'intro is-leaving' : 'intro'} aria-hidden='true'>
            <video
                ref={videoRef}
                className='intro-video'
                src={process.env.PUBLIC_URL + '/movies/top_animation.mp4'}
                autoPlay
                muted
                playsInline
            ></video>
        </div>
    )
}

export default Intro
